import ScrollMagic from "scrollmagic";

let slideRevealScrollController = new ScrollMagic.Controller()
let allSlideReveals = [...document.querySelectorAll('.slide-reveal')]


allSlideReveals.forEach(function(slideReveal) {
  let modifierClass = (slideReveal.getAttribute('data-direction') === 'right') ? 'slide-reveal--to-right' : 'slide-reveal--to-left'
  slideReveal.classList.add(modifierClass)

  new ScrollMagic.Scene({
    triggerElement: slideReveal,
    triggerHook: 0.75,
    reverse: false
  })
  .setClassToggle(slideReveal, 'slide-reveal--transition')
  .addTo(slideRevealScrollController);
})
